import * as Yup from 'yup'
import { OPTION_YES } from '../../../../../../constants/forms'
import { FEE, FEE_OPTION } from './fields'

export const marginFeeValidation = {
  [FEE]: Yup.number().when(FEE_OPTION, {
    is: OPTION_YES,
    then: () => Yup.number().required('Fee Required').max(50, 'Maximum number of fee - 50%')
  })
}
